import { combineReducers } from "redux";

import { ISeekTarget } from "../lib/AudiostorePlayer";
import { RootAction } from "../types";

function currentTime(state: number = 0, action: RootAction): number {
  switch (action.type) {
    case 'TIME_UPDATE':
      return action.payload;
    case 'PLAY_CLIP_REQUEST':
      return 0;
    default:
      return state;
  }
}

function isSeeking(state: boolean = false, action: RootAction): boolean {
  switch (action.type) {
    case 'MEDIA_EVENT':
      switch (action.payload) {
      case 'seeking':
        return true;
      case 'seeked':
        return false;
      case 'loadstart':
        return true;
      case 'loadeddata':
        return false;
      default:
        return state;
      }
    default:
      return state;
  }
}

function isPlaying(state: boolean = false, action: RootAction): boolean {
  switch (action.type) {
    case 'MEDIA_EVENT':
      switch (action.payload) {
      case 'play':
        return true;
      case 'pause':
        return false;
      default:
        return state;
      }
    default:
      return state;
  }
}

function recordingId(state: string | null = null, action: RootAction): string | null {
  switch (action.type) {
    case 'PLAY_CLIP_REQUEST':
      const {recording_id} = action.payload;
      return recording_id || state;
    default:
      return state;
  }
}

function showWaveform(state: boolean = false, action: RootAction): boolean {
  switch (action.type) {
    case 'TOGGLE_WAVEFORM':
      return !state;
    default:
      return state;
  }
}

function duration(state: number = 0, action: RootAction): number {
  switch (action.type) {
    default:
      return state;
  }
}

function playbackRate(state: number = 1, action: RootAction): number {
  switch (action.type) {
    case 'TOGGLE_PLAYBACK_RATE':
      return state >= 2 ? 0.5 : state + 0.5;

    default:
      return state;
  }
}

function seekTarget(state: ISeekTarget | null = null, action: RootAction): ISeekTarget | null {
  switch (action.type) {
    case 'PLAYER_SEEK':
      return action.payload;

    case 'PLAY_CLIP_REQUEST':
      const {start} = action.payload;

      return {
        isPlaying: true,
        time: start || 0,
        timeRelative: false,
      };
    
    case 'SET_PLAYING':
      return {
        isPlaying: action.payload,
        time: 0,
        timeRelative: true,
      };

    default:
      return state;
  }
}

export const playerReducer = combineReducers({
  currentTime,
  duration,
  isPlaying,
  isSeeking,
  playbackRate,
  recordingId,
  seekTarget,
  showWaveform,
});
export default playerReducer;



// WEBPACK FOOTER //
// ./src/reducers/playerReducer.ts